module.exports = __webpack_public_path__ + "img/pic2.5795e1ff.png";